import { COLUMN_IDS } from '../constants';

const tickerColIndex = COLUMN_IDS.indexOf('ticker');
const dateColIndex = COLUMN_IDS.indexOf('date');
const priceColIndex = COLUMN_IDS.indexOf('price');
const sharesColIndex = COLUMN_IDS.indexOf('shares');
const totalCostColIndex = COLUMN_IDS.indexOf('cost');
const typeColIndex = COLUMN_IDS.indexOf('type');

type DamagedCell = { cell: [number, number] };

export const getDamagedRow = (rowIndex: number): DamagedCell[] => [
  { cell: [tickerColIndex, rowIndex] },
  { cell: [dateColIndex, rowIndex] },
  { cell: [priceColIndex, rowIndex] },
  { cell: [sharesColIndex, rowIndex] },
  { cell: [totalCostColIndex, rowIndex] },
  { cell: [typeColIndex, rowIndex] },
];
